import React from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Grid, Box, Button, Divider } from '@mui/material';

const ProfileForm = () => {
	const handleFormSubmit = () => {};
	return (
		<Formik
			initialValues={{
				email: '',
				phone: '',
			}}
			onSubmit={handleFormSubmit}>
			{(formik) => {
				const { errors, setFieldValue } = formik;
				return (
					<Form>
						<Box style={{ padding: 10 }}>
							<Grid container style={{ marginTop: 5, padding: 10 }} spacing={4}>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										First Name*
									</span>
									<br></br>
									<Field
										name='email'
										type='text'
										placeHolder='Enter First Name'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.email ? '2px solid red' : '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.email ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.email}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										Last Name*
									</span>
									<br></br>
									<Field
										name='email'
										type='text'
										placeHolder='Enter Last Name'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.email ? '2px solid red' : '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.email ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.email}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										Mobile Number *
									</span>
									<br></br>
									<Field
										name='email'
										type='text'
										placeHolder='Enter Mobile Number'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.email ? '2px solid red' : '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.email ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.email}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										Agency Name
									</span>
									<br></br>
									<Field
										name='email'
										type='text'
										placeHolder='Enter Agency Name'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.email ? '2px solid red' : '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.email ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.email}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={3}>
									<Button
										type='submit'
										style={{
											background: 'rgb(25, 118, 210)',
											color: 'white',
											marginTop: 30,
											// padding: 16,
											borderRadius: 5,
											width: '100%',
										}}>
										Save
									</Button>
								</Grid>
							</Grid>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default ProfileForm;
